// Router initialization helper
export function initializeRouter() {
  console.log('[RouterInit] Starting router initialization...');
  
  // Wait for custom elements to be defined
  Promise.all([
    customElements.whenDefined('ewc-router-outlet'),
    customElements.whenDefined('ewc-route'),
    customElements.whenDefined('zoom-gears-page'),
    customElements.whenDefined('dashboard-page'),
    customElements.whenDefined('ui-library-demo')
  ]).then(() => {
    console.log('[RouterInit] All components defined');
    
    // Get the router
    const router = document.querySelector('ewc-router-outlet');
    if (!router) {
      console.error('[RouterInit] No router found!');
      return;
    }
    
    // Force the router to re-resolve the current path
    setTimeout(() => {
      console.log('[RouterInit] Forcing router to resolve current path:', window.location.pathname);
      
      // Check if router has navigate method
      if (router.navigate) {
        // Navigate to current path to force update
        router.navigate(window.location.pathname, true);
      } else {
        console.error('[RouterInit] Router does not have navigate method');
      }
      
      // Also check if content needs to be manually moved
      setTimeout(() => {
        if (router.shadowRoot) {
          const routeContent = router.shadowRoot.querySelector('#route-content');
          if (routeContent && routeContent.children.length === 0) {
            console.log('[RouterInit] Route content is empty, attempting manual fix...');
            
            // Find the zoom-gears-page component
            const zoomComp = document.querySelector('zoom-gears-page');
            if (zoomComp && zoomComp.parentElement?.tagName === 'EWC-ROUTE') {
              console.log('[RouterInit] Found component in route, cloning...');
              const clone = zoomComp.cloneNode(true);
              routeContent.appendChild(clone);
              customElements.upgrade(clone);
              console.log('[RouterInit] Component cloned and upgraded');
            }
          }
        }
      }, 100);
    }, 100);
  });
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeRouter);
} else {
  initializeRouter();
}